import { Message } from '../../../entities/ticket/model/types';
import { getTicketMessages as getTicketMessagesApi } from '../../../entities/ticket/api/ticketApi';

export class GetTicketMessagesUseCase {
  async execute(ticketId: string): Promise<Message[]> {
    return await getTicketMessagesApi(ticketId);
  }
}




